import { atom } from 'recoil';

export const ordState = atom<string|null>({
  key: 'ordState',
  default: null,
});


